import { render } from "./index.vue?vue&type=template&id=519057a8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=519057a8&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-519057a8"

export default script